import {h5ObtainProfile} from '../hybrid';

interface BlockItem {
    p: Promise<string>;
    r: (value: any) => void;
}

// 常规使用的 key，没有列举全部。
interface Profile {
    device: {
        version: string;
        versionCode: number;
        did: string;
        os: string;
    };
    user: {
        avatar: string;
        country: string;
        gendar: number;
        name: string;
        uid: string;
        userId: string;
    }
}

class GetProfile {
    profile?: Profile;
    block: BlockItem[] = [];
    constructor(){}
    // 通过 jsBridge 与 app 交互获取 profile
    async getAppProfile(selfItem: BlockItem){
        const asyncData = await h5ObtainProfile().then(profile => {
            if(profile){
                this.profile = profile;
                // 成功获取 profile 后释放所有阻塞 promise
                this.block.forEach(item => item.r(profile));
            };
            return profile;
        }).catch(async error => {
            // 获取失败后只释放当前请求的 promise
            const selfIndex = this.block.findIndex(item => item == selfItem);
            this.block.splice(selfIndex, 1);
            selfItem.r('获取失败');
            return {};
        });

        return asyncData;
    }
    async getProfile (){
        if(this.profile) return this.profile;

        let r: BlockItem['r'] = () => {};
        let p: BlockItem['p'] = new Promise(res => r = res);
        const item = {p, r};

        const lastPromise = this.block.slice(-1)[0];
        this.block.push(item);
        if(lastPromise) await lastPromise.p;
        // 通过 promise 阻塞后，前一个获取请求成功获取并设置 this.profile 值，此时直接返回 this.profile
        if(this.profile) return this.profile;
        //	获取异步 profile
        const asyncData = await this.getAppProfile(item);
        return asyncData;
    }
};

const instance = new GetProfile();

export default instance.getProfile.bind(instance);


